<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const PopularIcon = getIcon("PopularIcon");
</script>

{#if typeof PopularIcon === 'string'}
	<img src={PopularIcon} alt={$t(Verbiage.popular_icon_alt, 'alts')} />
{:else if typeof PopularIcon === 'function'}
	<svelte:component this={PopularIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
